import Vue from 'vue';
import vueSmoothScroll from 'vue2-smooth-scroll';
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';
import Question from '../components/Question.vue';

Vue.use(vueSmoothScroll);
Vue.use(vClickOutside);

Vue.component('vue-slide-up-down', SlideUpDown);

new Vue({
    el: '#site',
    data: {
        isOpen: false,
        switcherOpen: false,
        navOpen: false,
        searchOpen: false,
        mobileSwitcherOpen: false,
        newsLetterOpen: false,
    },
    components: {
        Question,
    },
    methods: {
        closeSwitcher() {
            this.switcherOpen = false;
        },
        closeMobileSwitcher() {
            this.mobileSwitcherOpen = false;
        },
    },
});
